import gql from "graphql-tag";

export const getSignedData = gql`
  query Policy {
    s3PostPolicy {
      url
      fields {
        algorithm
        bucket
        credential
        date
        key
        policy
        securityToken
        signature
      }
    }
  }
`;
